import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

export default function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />

      <section className="hero" style={{ minHeight: '30vh', paddingTop: '120px', paddingBottom: '40px' }}>
        <div className="container text-center">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <span className="badge">🔒 Security & Privacy</span>
            <h1 className="hero-title" style={{ fontSize: '3rem', marginTop: 16 }}>
              Privacy <span className="text-gradient">Policy</span>
            </h1>
            <p className="hero-subtitle" style={{ margin: '0 auto', maxWidth: 600 }}>
              Last updated: March 2026. Your privacy and security are our highest priority.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="section" style={{ paddingTop: 0 }}>
        <div className="container">
          <motion.div 
            initial={{ opacity: 0, y: 30 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.6, delay: 0.2 }}
            className="glass-card" 
            style={{ padding: '60px', maxWidth: 900, margin: '0 auto', textAlign: 'left', lineHeight: 1.8 }}
          >
            <h2 style={{ fontSize: '1.8rem', fontWeight: 700, marginBottom: 16, color: 'var(--text-primary)' }}>1. Introduction</h2>
            <p style={{ color: 'var(--text-secondary)', marginBottom: 32 }}>
              Welcome to the InfraVelox. We respect your privacy and are committed to protecting your personal data. This privacy policy will inform you as to how we look after your personal data when you visit our website (regardless of where you visit it from) and tell you about your privacy rights and how the law protects you.
            </p>

            <h2 style={{ fontSize: '1.8rem', fontWeight: 700, marginBottom: 16, color: 'var(--text-primary)' }}>2. Data We Collect About You</h2>
            <p style={{ color: 'var(--text-secondary)', marginBottom: 16 }}>
              Personal data, or personal information, means any information about an individual from which that person can be identified.
            </p>
            <ul style={{ color: 'var(--text-secondary)', marginBottom: 32, paddingLeft: 20 }}>
              <li style={{ marginBottom: 8 }}><strong>Identity Data:</strong> includes first name, last name, username or similar identifier.</li>
              <li style={{ marginBottom: 8 }}><strong>Contact Data:</strong> includes billing address, email address and telephone numbers.</li>
              <li style={{ marginBottom: 8 }}><strong>Financial Data:</strong> includes payment card details (processed securely via our payment gateways, Razorpay/Stripe; we do not store full card numbers).</li>
              <li style={{ marginBottom: 8 }}><strong>Profile Data:</strong> includes your username and password, purchases or orders made by you, your interests, preferences, and feedback.</li>
              <li style={{ marginBottom: 8 }}><strong>Usage Data:</strong> includes information about how you use our website, products and services.</li>
            </ul>

            <h2 style={{ fontSize: '1.8rem', fontWeight: 700, marginBottom: 16, color: 'var(--text-primary)' }}>3. How We Use Your Personal Data</h2>
            <p style={{ color: 'var(--text-secondary)', marginBottom: 32 }}>
              We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:
              <br/><br/>
              - Where we need to perform the contract we are about to enter into or have entered into with you (e.g., providing mentoring support).<br/>
              - Where it is necessary for our legitimate interests (or those of a third party) and your interests and fundamental rights do not override those interests.<br/>
              - Where we need to comply with a legal obligation.
            </p>

            <h2 style={{ fontSize: '1.8rem', fontWeight: 700, marginBottom: 16, color: 'var(--text-primary)' }}>4. Data Security</h2>
            <p style={{ color: 'var(--text-secondary)', marginBottom: 32 }}>
              We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used or accessed in an unauthorised way, altered or disclosed. In addition, we limit access to your personal data to those employees, agents, contractors and other third parties who have a business need to know.
            </p>

            <h2 style={{ fontSize: '1.8rem', fontWeight: 700, marginBottom: 16, color: 'var(--text-primary)' }}>5. Your Legal Rights</h2>
            <p style={{ color: 'var(--text-secondary)', marginBottom: 32 }}>
              Under certain circumstances, you have rights under data protection laws in relation to your personal data, including the right to request access, correction, erasure, restriction, transfer, to object to processing, to portability of data and to withdraw consent. If you wish to exercise any of the rights set out above, please contact us.
            </p>

            <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: 32, marginTop: 40, color: 'var(--text-muted)' }}>
              If you have any questions about this Privacy Policy, please contact us at <a href="mailto:privacy@infravelox.com" style={{ color: 'var(--brand-primary)', textDecoration: 'none' }}>privacy@infravelox.com</a>.
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </>
  );
}
